/* import __COLOCATED_TEMPLATE__ from './intro.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './intro.module.scss';

@classic
@classNames(styles.component)
export default class PracticeWebsiteIntro extends Component {}
